import { format, getTime, formatDistanceToNow, addDays } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// ----------------------------------------------------------------------

export function fDay(date) {
  return format(new Date(date), 'dd');
}

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy', { locale: ptBR }).toUpperCase();
}

export function fDate2(date) {
  return format(new Date(date), 'MMMM yyyy', { locale: ptBR }).toUpperCase();
}

export function fDate3(date) {
  return format(addDays(new Date(date), 1), 'dd/MM');
}

export function fDate4(date) {
  return format(new Date(date), 'dd/MM/yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}
